import { Theme, rem } from '@thiememeulenhoff/lit-sdk';
import { CSSResult, css, unsafeCSS } from 'lit';
import { token, IconSizes } from '@thiememeulenhoff/tokens';
import { tagName } from '../../helpers';

export const tag = tagName('icon');
const theme = new Theme(tag);

export const iconStyles = css`
  :host {
    display: inline-block;
  }

  :host(.embedded) {
    inset-block-start: 50%;
    inset-inline-end: ${rem(10)};
    position: absolute;
    transform: translateY(-50%);
  }

  :host(.embedded:not(.clickable)) {
    pointer-events: none;
  }

  :where(svg) {
    block-size: 100%;
    display: block;
    fill: currentColor;
    inline-size: 100%;
    overflow: visible;
  }
`;

const sizeStyles: Array<CSSResult> = [];

IconSizes.forEach((size: string) => {
  sizeStyles.push(
    unsafeCSS(`
    :host([size='${size}']) {
      ${theme.props([
        ['block-size', `${size}-icon-block-size`, token(`icon.size.${size}`)],
        ['inline-size', `${size}-icon-inline-size`, token(`icon.size.${size}`)],
      ])};
    })
  `),
  );
});

export const iconSizeStyles = sizeStyles;
